import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/services/api/api.service';
import { SetNewPasswordRequestBodyI } from './interfaces/set-new-password-request-body.interface';
import { CheckFirstTimeLoginRequestBodyI } from './interfaces/check-first-time-login-request-body.interface';
import { FirstTimeLoginI } from './interfaces/first-time-login.interface';

@Injectable({
  providedIn: 'root',
})
export class FirstTimeLoginApiService {
  constructor(private readonly apiService: ApiService) {}

  requestOtp(email: string) {
    return this.apiService.post<string>(`otps/first-time-login`, { email });
  }

  setNewPassword(setNewPasswordRequestBody: SetNewPasswordRequestBodyI) {
    return this.apiService.post<string>(
      `auth/first-time-login`,
      setNewPasswordRequestBody
    );
  }
  checkFirstTimeLogin(
    checkFirstTimeLoginRequestBody: CheckFirstTimeLoginRequestBodyI
  ) {
    return this.apiService.post<FirstTimeLoginI>(
      'otps/check-first-time-login',
      checkFirstTimeLoginRequestBody
    );
  }
}
